import { toast } from "react-toastify";
import { FaCheckCircle, FaInfoCircle, FaExclamationTriangle, FaTimesCircle } from "react-icons/fa";

const toastConfig = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  icon: false,
  style: {
    borderRadius: "8px",
    padding: "12px 16px",
    fontSize: "14px",
    fontWeight: 600,
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
};

export const showToast = {
  success: (message) => {
    toast.success(
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <FaCheckCircle color="#16a34a" /> {message}
      </div>,
      {
        ...toastConfig,
        style: {
          ...toastConfig.style,
        },
      }
    );
  },

  error: (message) => {
    toast.error(
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <FaTimesCircle color="#dc2626" /> {message}
      </div>,
      {
        ...toastConfig,
        style: {
          ...toastConfig.style,
        },
      }
    );
  },

  info: (message) => {
    toast.info(
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <FaInfoCircle color="#3b82f6" /> {message}
      </div>,
      {
        ...toastConfig,
        style: {
          ...toastConfig.style,
        },
      }
    );
  },

  warning: (message) => {
    toast.warning(
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <FaExclamationTriangle color="#facc15" /> {message}
      </div>,
      {
        ...toastConfig,
        style: {
          ...toastConfig.style,
        },
      }
    );
  },
};
